











































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import QuestionnaireDownloader from "@/components/QuestionnaireDownloader.vue";
import _ from "lodash";
import { mapGetters } from "vuex";

axios.defaults.baseURL = process.env.BASE_URL;

@Component({
  components: { QuestionnaireDownloader },
  computed: mapGetters(["getUser"])
})
export default class QuestionnaireExplorer extends Vue {
  @Prop({ default: false })
  displayHelp!: boolean;

  baseurl = process.env.BASE_URL;
  selected: any = null;
  getUser!: any;

  allQuestionnaires: any[] = [];
  searchQuery = "";

  mounted() {
    this.getAllQuestionnaires();
  }


  selectQ(a: any) {
    this.selected = a;
  }

  hoverAnswer(a: any, b: boolean) {
    if (!a.meta) a.meta = {};
    a.meta.hovered = b;
  }

  formatDate(date: any) {
    if (!date) return "";
    const d = (date instanceof Date) ? date : new Date(date);
    return d.toLocaleString();
  }

  getReferrerDisplay(a: any) {
    if (a.referrer) {
      if (a.referrer.origin && a.referrer.origin._type === "JobBoardFormCredit") return "Job Board";
      return a.referrer.origin?.userId || a.referrer;
    }
    return a.referrer || "—";
  }

  getNormatifTestId(answer: any) {
    return answer.testId || (answer.test && (answer.test._id || answer.test.id)) || null;
  }

  openNormatifAnswerInNewTab(answer: any) {
    const testId = this.getNormatifTestId(answer);
    const qId = answer.id || answer._id;
    if (!testId || !qId) {
      this.$toast?.error("ID du test ou de la réponse manquant");
      return;
    }
    const url = `${this.baseurl}normatif-questionnaire/${testId}?qId=${qId}&viewOnly=true`;
    window.open(url, "_blank");
  }

  async getAllQuestionnaires() {
    try {
      const qMetaRes = await axios.get("/api/questionnaires-metadata");
      const qList = (qMetaRes.data || []).map((e: any) => {
        e.creationDate = new Date(e.creationDate);
        if (e.modificationDate) e.modificationDate = new Date(e.modificationDate);
        e.meta = { hovered: false, isOpen: false, reloadingTxt: false };
        if (!e.qtype && e.type) e.qtype = e.type;
        return e;
      });

      // 2) EvaluationNeuroscienceQuestionnaire-metadata
      const neuRes = await axios.get("/api/EvaluationNeuroscienceQuestionnaire-metadata").catch(() => ({ data: [] }));
      const neuList = (neuRes.data || []).map((e: any) => {
        e.creationDate = new Date(e.creationDate);
        if (e.modificationDate) e.modificationDate = new Date(e.modificationDate);
        e.meta = { hovered: false, isOpen: false, reloadingTxt: false };
        e.qtype = "Evaluation Neurosciences";
        e.identity = { forname: e.userId || "", name: "", mail: e.userEmail || null };
        return e;
      });

      // 3) DeSI ACTIV
      const deSiRes = await axios.get("/api/DeSIACTIVquestionnaires-metadata").catch(() => ({ data: [] }));
      const DeSIACTIVquestionnaires = (deSiRes.data || []).map((e: any) => {
        e.creationDate = new Date(e.creationDate);
        if (e.modificationDate) e.modificationDate = new Date(e.modificationDate);
        e.meta = { hovered: false, isOpen: false, reloadingTxt: false };
        e.qtype = "DeSI-Activités";
        e.identity = { forname: e.userId || "", name: "", mail: e.userEmail || null };
        return e;
      });

      // 3a) DeSI premium 
      let deSiFinal = DeSIACTIVquestionnaires;
      try {
        const premiumRes = await axios.get("/api/DeSI_premium");
        const premiumData = premiumRes.data || [];
        const new_tab: any[] = [];
        DeSIACTIVquestionnaires.forEach((element1: any) => {
          let exists = false;
          premiumData.forEach((element2: any) => {
            if (element1['id'] == element2.activitiesId) {
              exists = true;
            }
          });
          if (exists === false) new_tab.push(element1);
        });
        deSiFinal = new_tab;
      } catch (err) {
        deSiFinal = DeSIACTIVquestionnaires;
      }

      // 4) Normatif a
      let normatifList: any[] = [];
      try {
        const normRes = await axios.get("/api/normatif-answers/complete");
        normatifList = (normRes.data || []).map((a: any) => {
          const item: any = {};
          item.id = a.id || a._id || a._uid;
          item._uid = a._id || a.id;
          item.creationDate = a.creation_date ? new Date(a.creation_date) : new Date();
          item.modificationDate = a.modification_date ? new Date(a.modification_date) : null;
          item.meta = { hovered: false, isOpen: false, reloadingTxt: false };
          item.qtype = a.test && a.test.name ? a.test.name : (a.testId || "Normatif");
          item.identity = {
            forname: a.user?.prenom || "",
            name: a.user?.nom || "",
            mail: a.user?.email || a.user?.id || ""
          };
          item.user = a.user || null; 
          item.test = a.test || null; 
          item.testId = a.testId || (a.test && (a.test._id || a.test.id)) || null;
          item.finished = !!a.finished; 
          item.source = "normatif";
          return item;
        });
      } catch (err) {
        console.error("Erreur chargement normatif:", err);
      }

      const combined = _.concat(qList, neuList, deSiFinal, normatifList);

      // sort by creationDate desc
      this.allQuestionnaires = _.orderBy(combined, [(e: any) => {
        const d = e.creationDate instanceof Date ? e.creationDate : new Date(e.creationDate);
        return d.getTime();
      }], ['desc']);

    } catch (e) {
      console.error("Erreur getAllQuestionnaires:", e);
      this.$toast?.error?.(e?.response?.data || "Erreur lors du chargement des questionnaires.");
      this.allQuestionnaires = [];
    }
  }

  get filteredQuestionnaires() {
    const arr = this.allQuestionnaires || [];
    if (!this.searchQuery) return arr;
    const q = this.searchQuery.toLowerCase();
    return arr.filter((a: any) => {
      const forname = (a.identity?.forname || "").toString().toLowerCase();
      const name = (a.identity?.name || "").toString().toLowerCase();
      const mail = (a.identity?.mail || a.user?.email || "").toString().toLowerCase();
      const company = (a.identity?.company || a.user?.company || "").toString().toLowerCase();
      const qtype = (a.qtype || "").toString().toLowerCase();
      return forname.includes(q) || name.includes(q) || mail.includes(q) || company.includes(q) || qtype.includes(q);
    });
  }
}
